import { InternalCompilerError } from './../../InternalCompilerError';
import { ReturnBlock } from "../ReturnBlock";
import { VarAssignBlock } from "../variable/VarAssignBlock";
import { VoidBlock } from "../VoidBlock";

/**
 * A block to represent a FOR loop (;; style). Creates incrementor variable, executes nodes while 
 * the condition holds, incrementing the incrementor variable by some value after each iteration.
 */
export class FORBlock extends VoidBlock {
    counterName;
    initialValue;
    condition;
    incrementValue;
    nodes;
    len;

    /**
     * Constructor
     * @param counterName name of counter variable
     * @param initialValue (number) counter initial value (0th index)
     * @param condition (boolean) condition for running (0th index)
     * @param incrementValue (number) value by which to increment (positive or negative; 0th index)
     * @param nodes array of nodes to execute while condition is true. These nodes are roots of trees that
     * need to be executed conditionaly (loop), hence they must be VoidBlocks.
     */
    constructor(id: string, counterName: string,
        initialValue: ReturnBlock[],
        condition: ReturnBlock[],
        incrementValue: ReturnBlock[],
        nodes: VoidBlock[]) {
        super(id)
        this.counterName = counterName;
        this.initialValue = initialValue[0];
        this.condition = condition[0];
        this.incrementValue = incrementValue[0];
        this.nodes = nodes;

        this.len = 0;
        for (let b of nodes) {
            this.len += b.getLength();
        }
    }

    *evalBlock(varEnv: Map<string, any>) {
        // using VarAssignBlock to create/assign the counter variable
        let countVarAssign = new VarAssignBlock(this.id, this.counterName, [this.initialValue]);
        countVarAssign.evalBlock(varEnv);

        while (true) {
            // condition
            let comp = Boolean(this.condition.evalBlock(varEnv));

            if (!comp) return; // stop if condition false

            // executing nodes
            for (let node of this.nodes) {
                if (!(node instanceof VoidBlock)) throw new InternalCompilerError('Loop body must be void');

                let gen = node.evalBlock(varEnv);
                let status;

                do {
                    status = gen.next();
                    yield;
                } while (!status.done);
            }

            let incrValue = this.incrementValue.evalBlock(varEnv);
            varEnv.set(this.counterName, varEnv.get(this.counterName) + incrValue);
        }
    }

    getLength() {
        return this.len;
    }
}